<div>
    <div class="row">
        <div class="col-12">
            <div id="clientList" class="card">
                <ng-container *ngTemplateOutlet="pickList"></ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #pickList>
    <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="fmsListService"
        [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"
        (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
        (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
        (resetListLayout) = "fmsListService.resetListState($event)"
        (searchTermChanged)="fmsListService.searchTerm = $event"
        (paginationSelected)="paginationUpdated(fmsListService,$event)" [serviceData]="serviceData"
        (pageSizeSelected)="fmsListService.pageSize = $event"></app-list-layout>
</ng-template>